// v-reveal — fade a block in as it scrolls into view.
//
// Replaces the AOS library the WordPress theme used:
//
//   <div v-reveal>…</div>              fade up
//   <div v-reveal:down="150">…</div>   fade down, 150 ms after it appears
//
// The element starts hidden via the `[data-reveal]` rules in site.css and gets
// `is_revealed` once it crosses into the viewport. One observer serves the
// whole page.

let observer = null

function watcher() {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is_revealed')
          observer.unobserve(entry.target)
        })
      },
      { rootMargin: '0px 0px -120px 0px' }
    )
  }
  return observer
}

export default {
  mounted(el, binding) {
    el.dataset.reveal = binding.arg || 'up'
    if (binding.value) el.style.setProperty('--reveal-delay', `${binding.value}ms`)

    // Anything already on screen at mount (the hero, mostly) should play its
    // animation straight away rather than wait for a scroll.
    watcher().observe(el)
  },

  unmounted(el) {
    if (observer) observer.unobserve(el)
  },
}
